// -> timestamp

// polyfilled ;)
module.exports = Date.now || function dateNow() {
    return new Date().getTime();
  };



//////////////////
// WEBPACK FOOTER
// /node_modules/cmnjs/date/now.js
// module id = 340
// module chunks = 0